import React from "react";
import "./CareerGuide.css";
import { useNavigate } from "react-router-dom";

export default function CareerGuidance() {
  const navigate = useNavigate();
  return (
    <div className="cg-page">

      {/* HERO */}
      <section className="cg-hero">
        <h1>
          Shape Your Career with <span className="text-nowrap">Talent Hive</span>
        </h1>
        <p>
          Smart guidance for candidates. Smarter hiring for employers.
        </p>
        <div className="cg-hero-actions">
          <button className="cg-primary">Start Career Guidance</button>
          <button className="cg-outline">Upload CV</button>
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section className="cg-steps">
        <h2>How Career Guidance Works</h2>

        <div className="step-grid">
          <div className="step-card">
            <span>01</span>
            <h3>Understand Yourself</h3>
            <p>
              Identify your interests, strengths, career goals, and experience
              level.
            </p>
          </div>

          <div className="step-card">
            <span>02</span>
            <h3>Explore Career Options</h3>
            <p>
              Discover roles, industries, growth paths, and salary expectations.
            </p>
          </div>

          <div className="step-card">
            <span>03</span>
            <h3>Improve Your Profile</h3>
            <p>
              Build a strong resume, improve skills, and prepare for interviews.
            </p>
          </div>

          <div className="step-card">
            <span>04</span>
            <h3>Get Hired Faster</h3>
            <p>
              Match with verified employers actively hiring on <text className="text-nowrap">Talent Hive</text>.
         
            </p>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="cg-cta">
        <h2>Your Career Journey Starts Here</h2>
        <p>
          Whether you are searching for a job or hiring talent, Talent Hive
          guides you at every step.
        </p>
        <button
          className="cg-primary big"
          onClick={() => navigate("/employee/signup")}
        >
          Get Started Now
        </button>
      </section>
    </div>
  );
}